export const URL = {
  GITHUB: "https://github.com/abhishekdipu",
  LINKEDIN: "https://www.linkedin.com/in/abhishekdipu/",
  TWITTER: "https://www.twitter.com/abhishekdipu/",
};
